export default "__VITE_ASSET__9251b48b__"